import { render } from "./purchasereturnlist.vue?vue&type=template&id=1abd9fec"
import script from "./purchasereturnlist.vue?vue&type=script&lang=js"
export * from "./purchasereturnlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__